export interface VimplayGameImageSet {
  webp?: string | null;
  org?: string | null;
}

export interface VimplayGameImages {
  sq?: VimplayGameImageSet | null;
  ls?: VimplayGameImageSet | null;
  pr?: VimplayGameImageSet | null;
}

export interface VimplayGame {
  id?: number | null;
  name?: string | null;
  type?: string | null;
  images?: VimplayGameImages | null;
}

export function vimplayGameImage(game: VimplayGame): string {
  return game.images?.sq?.webp || game.images?.sq?.org || "";
}

export function normalizeVimplayGames(data: unknown): VimplayGame[] {
  if (Array.isArray(data)) return data as VimplayGame[];
  if (data && typeof data === "object" && Array.isArray((data as { games?: unknown }).games)) {
    return (data as { games: VimplayGame[] }).games;
  }
  return [];
}
